import { addServiceAccountGiftCredits } from './addServiceAccountGiftCredits';
import { chargeUserForGourmetWithPartnerSubsidyIfAvailable } from './chargeUserForGourmetWithPartnerSubsidyIfAvailable';
import { checkAndRecordGourmetPopup } from './checkAndRecordGourmetPopup';
import { deleteSavedOrders } from './deleteSavedOrders';
import { getActiveOrders } from './getActiveOrders';
import { getInactiveOrders } from './getInactiveOrders';
import { getItemDetails } from './getItemDetails';
import { getOrderRatingData } from './getOrderRatingData';
import { getOrders } from './getOrders';
import { getOrdersWithEstimation } from './getOrdersWithEstimation';
import { getSavedOrders } from './getSavedOrders';
import { getStoreItems } from './getStoreItems';
import { getStores } from './getStores';
import { getUnresolvedOrders } from './getUnresolvedOrders';
import { gourmetGetEstimate } from './gourmetGetEstimate';
import { gourmetGetPreEstimate } from './gourmetGetPreEstimate';
import { markDeliveryOrderAsCanceled } from './markDeliveryOrderAsCanceled';
import { markDeliveryOrderAsCompleted } from './markDeliveryOrderAsCompleted';
import { markDeliveryOrderAsDoNotCharge } from './markDeliveryOrderAsDoNotCharge';
import { markDeliveryOrderAsNotDelivered } from './markDeliveryOrderAsNotDelivered';
import { payForAnyUnpaidGourmetOrders } from './payForAnyUnpaidGourmetOrders';
import { printStores } from './printStores';
import { getCallerTipGourmet } from './getCallerTipGourmet';
import { resolveOrderWithoutReorder } from './resolveOrderWithoutReorder';
import { saveGourmetOrder } from './saveGourmetOrder';
import { saveScheduledOrder } from './saveScheduledOrder';
import { sendSMSMessages } from './sendSMSMessages';
import { submitManualOrder } from './submitManualOrder';
import { submitOrder } from './submitOrder';
import { submitOrderRate } from './submitOrderRate';
import { updateCallerTipGourmet } from './updateCallerTipGourmet';
import { updateDeliveryInstructions } from './updateDeliveryInstructions';
import { updateDriverConfirmedMonitoringCall } from './updateDriverConfirmedMonitoringCall';

export const gourmetService = {
  addServiceAccountGiftCredits,
  chargeUserForGourmetWithPartnerSubsidyIfAvailable,
  checkAndRecordGourmetPopup,
  deleteSavedOrders,
  getActiveOrders,
  getInactiveOrders,
  getItemDetails,
  getOrderRatingData,
  getOrders,
  getOrdersWithEstimation,
  getSavedOrders,
  getStoreItems,
  getStores,
  getUnresolvedOrders,
  gourmetGetEstimate,
  gourmetGetPreEstimate,
  markDeliveryOrderAsCanceled,
  markDeliveryOrderAsCompleted,
  markDeliveryOrderAsDoNotCharge,
  markDeliveryOrderAsNotDelivered,
  payForAnyUnpaidGourmetOrders,
  printStores,
  getCallerTipGourmet,
  resolveOrderWithoutReorder,
  saveGourmetOrder,
  saveScheduledOrder,
  sendSMSMessages,
  submitManualOrder,
  submitOrder,
  submitOrderRate,
  updateCallerTipGourmet,
  updateDeliveryInstructions,
  updateDriverConfirmedMonitoringCall,
};
